import React from 'react';

export const phoneSupport = '1-800-874-5881';
export const PhoneSupport = <a href={`tel:${phoneSupport}`}>{phoneSupport}</a>;
